import { render, staticRenderFns } from "./TopAppBar.vue?vue&type=template&id=1fa13224&"
import script from "./TopAppBar.vue?vue&type=script&lang=js&"
export * from "./TopAppBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports